import {
  Avatar,
  Box,
  Button,
  Flex,
  FormControl,
  FormLabel,
  Image,
  Input,
  Stack,
  Text,
  useToast,
} from "@chakra-ui/core";
import React from "react";
import { useForm } from "react-hook-form";
import { useHistory } from "react-router";
import { register } from "../../../api/auth.service";
import { uploadFile } from "../../../api/media.service";
import { updateMentorProfile } from "../../../api/mentor.service";
import {
  getUserProfile,
  updateProfile,
  updateUserById,
} from "../../../api/user.service";
import useAuth from "../../../context/AuthContext";

const UploadAvatar = () => {
  const initialProfile = {
    first_name: "",
    last_name: "",
    email: "",
    phone_number: "",
    gender: "",
    profile: {},
  };

  const [profile, setUserProfile] = React.useState(initialProfile);
  const { register, handleSubmit } = useForm();
  const [isLoading, setIsLoading] = React.useState(false);
  const [isImageUploading, setIsImageUploading] = React.useState(false);
  const [profilePictureUrl, setProfilePicture] = React.useState("");
  const [isProfileSet, setIsProfileSet] = React.useState(false);
  const [hasFileSelect, setHasFileSelect] = React.useState(false);
  const {
    state: { user },
  } = useAuth();

  const history = useHistory();

  const toast = useToast();

  const updateProfileImage = async (image) => {
    try {
      setIsImageUploading(true);
      console.log({ profileLOaded: profile, image });
      const profileData = {
        ...profile,
        photo_url: image,
      };
      console.log(profileData);
      const { data } = await updateMentorProfile(profileData);
      toast({
        title: "Profile Picture Upload",
        description: "Profile Picture uploaded successfully",
        status: "success",
        isClosable: true,
        position: "top",
      });
      history.push("/dashboard/me");
    } catch (error) {
      toast({
        title: "Profile Picture Upload",
        description: "Profile Picture Upload failed. Please try again",
        position: "top",
        duration: 2500,
        status: "error",
      });
      setIsImageUploading(false);
    }
  };

  const onSubmit = async (values) => {
    try {
      setIsLoading(true);
      const formData = new FormData();
      formData.append("file", values.photo_url[0], values.photo_url[0].name);
      formData.append("type", "image");
      const { data } = await uploadFile(formData);
      setProfilePicture(data.url);
      data?.url.length > 0 && setIsProfileSet(true);
      setHasFileSelect(false);
      setIsLoading(false);
    } catch (error) {
      console.log(error);
      setIsLoading(false);
    }
  };

  React.useEffect(() => {
    const fetchUserProfile = async () => {
      try {
        const { data } = await getUserProfile();
        const {
          benefit,
          biography,
          experience,
          expertise,
          motivation,
          nationality,
          research_interests,
          residential_address,
          skills,
          title,
        } = data.mentor;
        data &&
          setUserProfile({
            benefit,
            biography,
            experience,
            expertise,
            motivation,
            nationality,
            research_interests,
            residential_address,
            skills,
            title,
          });
      } catch (error) {
        console.log("err", error);
      }
    };

    fetchUserProfile();
  }, []);
  return (
    <Box height='100%' w={["100%", "70%"]} mx='auto'>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Box
          display='flex'
          flexDirection='column'
          alignItems='center'
          flex='1'
          w='100%'
        >
          <Text
            fontWeight='700'
            textAlign='center'
            fontSize='xl'
            my={["2", "8"]}
          >
            Upload Profile Picture
          </Text>
          <Flex
            direction='column'
            width='100%'
            height={["auto", "80%"]}
            boxShadow='md'
            border='1px solid #EDF2F7'
            p={["0", "4"]}
            align='center'
          >
            <Box>
              {user.gender === null ? (
                <Avatar
                  src='https://bit.ly/broken-link'
                  bg='green.400'
                  size='sm'
                />
              ) : user.gender === "male" ? (
                <Image
                  w='100px'
                  h='100px'
                  objectFit='cover'
                  src={
                    profilePictureUrl ? profilePictureUrl : profile?.photo_url
                  }
                  alt='User Avatar'
                  rounded='full'
                  fallbackSrc='https://img.icons8.com/color/92/000000/user-male-circle--v1.png'
                />
              ) : (
                <Image
                  w='100px'
                  h='100px'
                  objectFit='cover'
                  src={
                    profilePictureUrl ? profilePictureUrl : profile?.photo_url
                  }
                  alt='User Avatar'
                  rounded='full'
                />
              )}
            </Box>
            <Box
              display='flex'
              flexDirection={["column", "row"]}
              rounded='10px'
            >
              <FormControl mt='15px'>
                <FormLabel htmlFor='photo_url'>Profile Picture</FormLabel>
                <Input
                  type='file'
                  name='photo_url'
                  ref={register}
                  onChange={() => setHasFileSelect(true)}
                />
              </FormControl>
            </Box>
            <Stack isInline spacing='4'>
              <Button
                type='submit'
                my='10'
                isLoading={isLoading}
                isDisabled={!hasFileSelect}
              >
                Upload Picture
              </Button>

              {isProfileSet && (
                <Button
                  onClick={() => updateProfileImage(profilePictureUrl)}
                  my='10'
                  isLoading={isImageUploading}
                >
                  Set as Profile Picture
                </Button>
              )}
            </Stack>
          </Flex>
        </Box>
      </form>
    </Box>
  );
};

export default UploadAvatar;
